import { Serializable } from 'types/interfaces';
import DetallesCupsMulticau, { DetallesCupsMulticauAPI } from './detallesCupsMulticau';

export interface SolicitudesAPI {
  solicitudId: number;
  cups: string;
  nombre: string;
  acceptada: 'si' | 'no';
  propietario: 'si' | 'no';

  solicitante: string;
  detallesCupsMulticau?: DetallesCupsMulticauAPI[];
}

export default class Solicitudes implements Serializable<Solicitudes> {
  solicitudId: number;

  cups: string;

  nombre: string;

  solicitante: string;

  acceptada: 'si' | 'no';

  propietario: 'si' | 'no';

  detallesCupsMulticau?: DetallesCupsMulticauAPI[];

  deserialize(input: SolicitudesAPI): Solicitudes {
    if (!input) {
      return this;
    }

    this.solicitudId = input.solicitudId || 0;
    this.cups = input.cups || '';
    this.nombre = input.nombre || '';
    this.solicitante = input.solicitante || '';

    this.acceptada = input.acceptada || 'no';
    this.propietario = input.propietario || 'no';
    this.detallesCupsMulticau = (input.detallesCupsMulticau || []).map((detalle) => new DetallesCupsMulticau(detalle));
    return this;
  }

  deserializeArray(inputArray: Array<SolicitudesAPI>): Array<Solicitudes> {
    const SolicitudesArray: Array<Solicitudes> = inputArray.map((input) => new Solicitudes().deserialize(input));

    return SolicitudesArray;
  }
}
